import { render, staticRenderFns } from "./SoundEffectCard.vue?vue&type=template&id=2194a592&scoped=true"
import script from "./SoundEffectCard.vue?vue&type=script&lang=js"
export * from "./SoundEffectCard.vue?vue&type=script&lang=js"
import style0 from "./SoundEffectCard.vue?vue&type=style&index=0&id=2194a592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2194a592",
  null
  
)

export default component.exports